import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const PageSEO = ({ title }) => {
  const pageTitle = `${title} — Infotech.Works`;
  return (
    <Helmet>
      <title>{pageTitle}</title>
    </Helmet>
  );
};

export default PageSEO;
